<template>
<div>
    <AuthForm />
    <Join />
    <SignupForm />
    <InfoPopup />
    <Agreement />
    <BecomePro />
    <DeleteComment />
    <DeleteGroup />
    <DeletePhoto />
    <DeletePost />
    <DeleteReply />
    <LeaveGroup />
    <PleaseLogIn />
    <PostForm />
    <SearchCardCollection />
    <Thanks />
    <CollectionVideoPreview />
</div>
</template>

<script>
    import AuthForm from './auth/AuthForm'
    import Join from './auth/Join'
    import SignupForm from './auth/SignupForm'
    import InfoPopup from './auth/Info'
    import Agreement from './auth/Agreement'
    import BecomePro from './BecomePro'
    import DeleteComment from './DeleteComment'
    import DeleteGroup from './DeleteGroup'
    import DeletePhoto from './DeletePhoto'
    import DeletePost from './DeletePost'
    import DeleteReply from './DeleteReply'
    import LeaveGroup from './LeaveGroup'
    import PleaseLogIn from './PleaseLogIn'
    import PostForm from './PostForm'
    import SearchCardCollection from './SearchCardCollection'
    import Thanks from './Thanks'
    import CollectionVideoPreview from './CollectionVideoPreview'

    export default {
        name: 'App',
        components: {
            AuthForm,
            Join,
            SignupForm,
            InfoPopup,
            Agreement,
            BecomePro,
            DeleteComment,
            DeleteGroup,
            DeletePhoto,
            DeletePost,
            DeleteReply,
            LeaveGroup,
            PleaseLogIn,
            PostForm,
            SearchCardCollection,
            Thanks,
            CollectionVideoPreview,
        },
    }
</script>